function CustomizeIcon() {
  return (
    <span className="anticon anticon-customize">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
      >
        <path
          stroke="Currentcolor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
          d="M18.334 5.417h-5M5 5.417H1.665M8.333 8.333a2.917 2.917 0 100-5.833 2.917 2.917 0 000 5.833zM18.333 14.583H15M6.666 14.583h-5M11.667 17.5a2.917 2.917 0 100-5.833 2.917 2.917 0 000 5.833z"
        />
      </svg>
    </span>
  );
}

export default CustomizeIcon;
